export const DEFAULT_ZAP_NAME = 'Name your zap';
export const QUERY_KEY = 'zapData';
export const SUPPORT_BFF_ENDPOINT = '/zap_block';
